import React from 'react'
import { Col, FormInput, FormGroup } from 'shards-react'
import PropTypes from 'prop-types'

export const SearchbarInput = ({ onFilterTextChange, disabled }) => {
    return (
        <Col sm="12" lg="6">
            <FormGroup>
                <FormInput
                    disabled={disabled}
                    name="miniAppSearchBar"
                    id="filter-text-box"
                    autoFocus
                    placeholder="Pesquise algum Eitri-App aqui. (nome, titulo, slug, feature toggle ou public key)"
                    onChange={e => onFilterTextChange(e.target.value)}
                />
            </FormGroup>
        </Col>
    )
}

SearchbarInput.propTypes = {
    onFilterTextChange: PropTypes.func,
}

export default SearchbarInput
